import { render, staticRenderFns } from "./FieldsetFixedAssetGeneral.yaml?vue&type=template&id=2611b83a&component"
import script from "./FieldsetFixedAssetGeneral.yaml?vue&type=script&lang=ts&component"
export * from "./FieldsetFixedAssetGeneral.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports